import { render } from "./TooltipLearn.vue?vue&type=template&id=c0f47e0e&ts=true"
import script from "./TooltipLearn.vue?vue&type=script&lang=ts"
export * from "./TooltipLearn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__